var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-body"},[_c('promo-bar-test'),_vm._v(" "),_c('layout-header',{attrs:{"hide-menu":_vm.isSeller}}),_vm._v(" "),_c('div',{staticClass:"container main-container main-content new-messenger-layout"},[_c('nuxt')],1),_vm._v(" "),_c('global-layout',{attrs:{"hide-scroll-top":"","hide-cart-trigger":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }